import { Injectable } from '@angular/core';
import { User } from '../models/user.model';
import { MealPlan, SupplementProtocol, CardioProgram } from '../models';
import { DatabaseService } from './database.service';
import { WorkoutProgram } from '../models/training/workout-program.model';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

    activeClient: User;
    user: User;

    constructor(
        private dbService: DatabaseService,
    ) { }

    public activeClientDisabled(status = ["disabled", "inactive", "lead"]) {
        return this.activeClient && status.indexOf(this.activeClient.status) > -1;
    }

    // ProgressReports
    public async getProgressReports(clientId) {
        const snapshot = this.dbService.getSnapshot(`/progressReports/${clientId}`);
        return transformFirebaseObjectToArray(snapshot);
    }

    public getProgressReportsList(clientId) {
        return this.dbService.getListByRefTest(`progressReports/${clientId}`);
    }

    // Training Programs
    public async getWorkoutPrograms(clientId) {
        const snapshot = await this.dbService.getSnapshot(`/workoutPrograms/users/${clientId}`);
        return transformFirebaseObjectToArray(snapshot);
    }

    public getWorkoutProgramsList(clientId) {
      return this.dbService.getListByRef<WorkoutProgram>(`workoutPrograms/users/${clientId}`, "id");
    }

    // Meal Plans
    public async getMealPlans(clientId) {
        const snapshot = await this.dbService.getSnapshot(`/mealPlans/${clientId}`);
        return transformFirebaseObjectToArray(snapshot);
    }

    public getMealPlansList(clientId) {
        return this.dbService.getListByRef<MealPlan>(`mealPlans/${clientId}`, 'id')
    }

    // Supplement Protocols
    public async getSupplementProtocols(clientId) {
        const snapshot = await this.dbService.getSnapshot(`/supplementProtocols/${clientId}`);
        return transformFirebaseObjectToArray(snapshot);
    }

    public getSupplementProtocolsList(clientId) {
        return this.dbService.getListByRef<SupplementProtocol>(`supplementProtocols/${clientId}`, "id");
    }

    // Cardio Programs
    public async getCardioPrograms(clientId) {
        const snapshot = await this.dbService.getSnapshot(`/cardioPrograms/${clientId}`);
        return transformFirebaseObjectToArray(snapshot);
    }

    public getCardioProgramsList(clientId) {
        return this.dbService.getListByRef<CardioProgram>(`cardioPrograms/${clientId}`, "id");
    }
}

function transformFirebaseObjectToArray(obj) {
    let results = []
    for (const id in obj) {
        if (obj.hasOwnProperty(id)) {
            let item = obj[id];
            item.id = id;
            results.push(item);
        }
    }
    return results
}